import Section from "@/components/Section";
import { Eye, EyeOff, Film } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function VideoUpload ({ videos = [], pricing, handleVideos, removeVideo, toggleVideo }) {
	const { t } = useTranslation();

	return (
		<Section title={ t('horse.video_section') }>
			<p className="text-sm text-[#666055] mb-4" data-testid="video-pricing-info">
				{ t('horse.video_pricing', {
					limit: pricing.free_videos_limit,
					price: pricing.price_extra_video?.toFixed(2),
					size: pricing.max_video_size_mb
				}) }
			</p>
			<div className="space-y-3">
				{ videos.map((vid, i) => (
					<div key={ i }
							 className={ `flex items-center gap-3 px-4 py-3 rounded-sm transition-all ${ vid.enabled ? 'bg-[#F2F0E9]' : 
								 	'bg-gray-100 opacity-50' }` }
							 data-testid={ `video-item-${ i }` }>
						<div className="w-20 h-14 rounded overflow-hidden bg-black flex-shrink-0">
							{ vid.isExisting ? (
								<video src={ vid.preview } className="w-full h-full object-cover" muted preload="metadata"
											 crossOrigin="anonymous"/>
							) : (
								<video src={ vid.preview } className="w-full h-full object-cover" muted preload="metadata"/>
							) }
						</div>
						<Film className="w-5 h-5 text-[#8B4513] flex-shrink-0"/>
						<span className="text-sm text-[#1A3C34] flex-1 truncate">{ vid.name || vid.url }</span>
						{ vid.isExisting &&
							<span className="text-[10px] bg-[#1A3C34] text-white px-2 py-0.5 rounded">
								{ t('common.saved') }
							</span>
						}
						{ !vid.isExisting && vid.file &&
							<span className="text-xs text-[#666055]">
								{ (vid.file.size / (1024 * 1024)).toFixed(1) }MB
							</span>
						}
						<button type="button" onClick={ () => toggleVideo(i) }
										className={ `w-7 h-7 rounded-full flex items-center justify-center ${ vid.enabled ? 'bg-green-600' : 
											'bg-gray-400' } text-white` }
										data-testid={ `video-toggle-${ i }` }>
							{ vid.enabled ?
								<Eye className="w-3.5 h-3.5"/> : <EyeOff className="w-3.5 h-3.5"/>
							}
						</button>
						{ !vid.isExisting && (
							<button type="button" onClick={ () => removeVideo(i) }
											className="text-[#9B2C2C] text-xs hover:underline"
											data-testid={ `video-remove-${ i }` }>
								{ t('horse.remove') }
							</button>
						) }
					</div>
				)) }
				<label
					className="flex items-center gap-3 px-4 py-4 border-2 border-dashed border-[#E6E2D6] rounded-sm cursor-pointer
							hover:border-[#8B4513] transition-colors"
					data-testid="video-upload">
					<Film className="w-6 h-6 text-[#8B4513]"/>
					<span className="text-sm text-[#666055]">
						{ t('horse.upload_video_label') } — Max { pricing.max_video_size_mb }MB
					</span>
					<input type="file" accept="video/*" multiple onChange={ handleVideos } className="hidden"/>
				</label>
			</div>
		</Section>

	)
}